export default __webpack_public_path__ + "static/media/banner-dark.928b88b7.png";